import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {DeckType} from '../../shared/card-deck';

export interface SelectedCard {
  id: number;
  cardDeckId: number;
  cardDeckType: DeckType;
}


@Injectable({
  providedIn: 'root'
})
export class CardSelectionService {
  private selectedCardSubject = new BehaviorSubject<SelectedCard | null>(null);
  selectedCard$ = this.selectedCardSubject.asObservable();

  selectCard(card: SelectedCard) {
    this.selectedCardSubject.next(card);
  }

  clear() {
    this.selectedCardSubject.next(null);
  }

}
